<template>
  <div class="main drag" id="Drag" @mousedown="mousedown($event)"  >

    <div class="title">
      <div class="title-content">换算小助手 </div>
      <div class="title-content right" ><i class="el-icon-close" @click="closeUtil"></i></div>
    </div>

     <div>
       <el-input placeholder="" v-model="inputValue" class="input-class" @input="cal">
         <el-select v-model="select1" @change="cal" slot="append" placeholder=""  class="select-class">
           <el-option v-for="item in temperatureOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
         </el-select>
       </el-input>

       <el-button type="text" style="margin: 0 20px" size="medium" @click="reverseUnit"><i class="el-icon-refresh"></i></el-button>

       <el-input placeholder="" v-model="inputValue2" class="input-class" @input="cal2">
         <el-select v-model="select2" slot="append" @change="cal" placeholder="" class="select-class">
           <el-option v-for="item in temperatureOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
         </el-select>
       </el-input>
     </div>


        <!-- 摩尔质量 -->
<!--        <div style="margin-top: 30px">-->
<!--          <el-input placeholder="" v-model="molInputValue" class="input-class" @input="molCal">-->
<!--            <el-select v-model="molSelect1" @change="molCal" slot="append" placeholder=""  class="select-class">-->
<!--              <el-option v-for="item in molOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--            </el-select>-->
<!--          </el-input>-->

<!--          <el-button type="text" size="medium" @click="reverseMolUnit"><i class="el-icon-refresh"></i></el-button>-->

<!--          <el-input placeholder="" v-model="molInputValue2" class="input-class" @input="molCal">-->
<!--            <el-select v-model="molSelect2" slot="append" @change="molCal" placeholder="" class="select-class">-->
<!--              <el-option v-for="item in molOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--            </el-select>-->
<!--          </el-input>-->
<!--        </div>-->


  </div>
</template>

<script>
export default {
  name: 'Calculator',
  data() {
    return {
      DragEl: null, //拖动元素
      totalHeight: null,
      totalWidth: null,
      // 位置差
      disX: 0,
      disY: 0,
      inputValue:"",
      inputValue2:"",
      select1:'f',
      select2:'c',
      temperatureOptions:[
        {label:'℃',value:'c'},
        {label:'℉',value:'f'}
      ],
      molInputValue:"",
      molInputValue2:"",
      molSelect1:'mol',
      molSelect2:'g',
      molOptions:[
        {label:'mmol',value:'mmol'},
        {label:'mol',value:'mol'},
        {label:'g',value:'g'},
        {label:'mg',value:'mg'},
        {label:'mL',value:'mL'},
        {label:'uL',value:'uL'},
      ],
    };
  },
  mounted() {
    this.DragEl = document.getElementById("Drag");
    this.totalHeight = window.innerHeight;
    this.totalWidth = window.innerWidth;
    console.log(this.totalHeight, this.totalWidth)
  },
  methods:{
    closeUtil(){
      this.$emit('close',false);
    },
    molCal(){
      this.molInputValue += ""
      this.molInputValue2 += ""
      if(this.molInputValue.trim()=="" && this.molInputValue2.trim()==""){
        return ;
      }

      if(this.molSelect1 == 'mol' && this.molSelect2 == 'mmol'){
        this.molInputValue2 = this.molInputValue * 1000
      }else if(this.molSelect1 == 'mmol' && this.molSelect2 == 'mol'){
        this.molInputValue2 = this.molInputValue / 1000
      }


    },
    reverseMolUnit(){

    },
    reverseUnit(){
      let temp = this.select1;
      this.select1 = this.select2;
      this.select2 = temp;
      this.cal()
    },

    cal(){
      this.inputValue += ""
      this.inputValue2 += ""
      if(this.inputValue.trim()=="" && this.inputValue2.trim()==""){
        return ;
      }
      if(this.select1 == 'c' && this.select2 == 'f'){
        this.inputValue2 = this.inputValue * 1.8 + 32;
      }else if(this.select1 == 'f' && this.select2 == 'c'){
        this.inputValue2 = (this.inputValue - 32)/1.8
      }else if(this.select1 == this.select2){
        this.inputValue2 = this.inputValue;
      }


      this.inputValue += ""
      this.inputValue2 += ""
      if(this.inputValue.trim()=="" || this.inputValue2.trim()==""){
        this.inputValue = ""
        this.inputValue2 = ""
      }
    },
    cal2(){
      this.inputValue += ""
      this.inputValue2 += ""
      if(this.inputValue.trim()=="" && this.inputValue2.trim()==""){
        return ;
      }
      if(this.select1 == 'c' && this.select2 == 'f'){
        this.inputValue = (this.inputValue2 - 32)/1.8
      }else if(this.select1 == 'f' && this.select2 == 'c'){
        this.inputValue = this.inputValue2 * 1.8 + 32;
      }else if(this.select1 == this.select2){
        this.inputValue = this.inputValue2;
      }

      this.inputValue += ""
      this.inputValue2 += ""
      if(this.inputValue.trim()=="" || this.inputValue2.trim()==""){
        this.inputValue = ""
        this.inputValue2 = ""
      }
    },

    /* 鼠标按下 */
    mousedown(event) {
      // 1,计算位置差
      // 因为clientX和offsetLeft的属性返回的位置不一样 要相减得到鼠标在拖动元素内实际点击的位置
      // 后面每一次拖动时都要减去这个差值 否则就会造成你拖动的位置一直都是元素的左上角 而不是你之前点击的位置
      this.disX = event.clientX - this.DragEl.offsetLeft;
      this.disY = event.clientY - this.DragEl.offsetTop;

      //2， 获取拖动元素的高度和容器的高度 为了下面进行限制元素拖动的范围
      let dragHeight = this.DragEl.offsetHeight;
      let dragWidth = this.DragEl.offsetWidth;

      // 添加鼠标移动事件
      document.onmousemove = (el) => {
        // 3，获取鼠标移动位置
        let moveX = el.clientX - this.disX;
        let moveY = el.clientY - this.disY;
        console.log(moveX, moveY)
        // 4，限制拖动
        //控制范围：在元素 被拖拽的过程中 判断 元素的定位值 是否到达边界 如果到了 就不能在走了

        //4.1第一种 限制范围的判断
        // if(moveX <=0 || moveY <=0){ // 控制上边界和左边界
        //   return
        // }
        // if(moveX >= dragContainerWidth - dragWidth || moveY >= dragContainerHeight - dragHeight){
        //   return
        // }

        // 4.2 第二种限制方位的判断 建议使用第二种； 第一种靠边时经常会有边距，不太丝滑
        // 左边界
        if (moveX <= 210) {
          moveX = 210;
        }
        // 右边界 减去的值为div的宽度
        if (moveX >= this.totalWidth-50 ) {
          moveX = this.totalWidth-50  ;
        }
        // 上边界
        if (moveY <= 50) {
          moveY = 50;
        }
        // 上边界减去的值为div的高度
        if (moveY >= this.totalHeight-50) {
          moveY = this.totalHeight-50;
        }
        // 5, 开始移动
        this.DragEl.style.left = moveX + "px";
        this.DragEl.style.top = moveY + "px";
      };
      /* 6，鼠标抬起解除事件 */
      document.onmouseup = () => {
        document.onmousemove = null;
      };
    },
  }
}
</script>

<style scoped>
.title-content{
  display: inline-block;
}
.right{
  float: right;
  right: 20px;
}
.right:hover{
  background-color: red;
  color: white;
}
.title{
  font-size: 17px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 10px;

}
.container{
   display: inline-block;
    height: 40px;
}
.img{
  display: inline-block;
  line-height: 40px;
}
.img-container{
  display: inline-block;
  height: 40px;
  width: 40px;
}
.select-class{
  width: 80px;
}
.input-class{
  width: 240px;
}
.main{
  position: fixed;
  background-color: #f0f3f9;
  border: 1px solid #e8e8e8;
  padding: 10px 10px;
  text-align: center;
  left: 50%;
  top: 50%;
}
.drag {

}
</style>